exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (C) 2016 Sergey Akopkokhyants\n * This project is licensed under the terms of the MIT license.\n * https://github.com/akserg/ng2-slim-loading-bar\n */\n\n\n/* Styling for the Slim Loading Progress Bar container */\n.slim-loading-bar {\n    position: fixed;\n    margin: 0;\n    padding: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 99999;\n}\n\n/* Styling for the Slim Loading Progress Bar itself */\n.slim-loading-bar-progress {\n    margin: 0;\n    padding: 0;\n    z-index: 99998;\n    background-color: green;\n    color: green;\n    box-shadow: 0 0 10px 0; /* Inherits the font color */\n    height: 2px;\n    opacity: 0;\n\n    /* Add CSS3 styles for transition smoothing */\n    transition: all 0.5s ease-in-out;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Desenvolvimento/PMP/painel/~/postcss-loader?{"ident":"postcss"}!/Desenvolvimento/PMP/painel/~/ng2-slim-loading-bar/style.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../ng2-slim-loading-bar/style.css
// module chunks = 34